import { useRef, useEffect } from 'react'
import type { FC } from 'react'
import { CALENDLY_LINK } from '~/settings'

const Calendly: FC<{ email: string | null }> = ({ email }) => {
	const el = useRef(null)

	const loadCalendly = () => {
		if (email) {
			window.Calendly.initInlineWidget({
				url: CALENDLY_LINK,
				parentElement: el.current,
				prefill: {
					email: email,
				},
				utm: {},
			})
		}
	}

	const loadScript = () => {
		const acceptedMarketing = window.Cookiebot?.consent?.marketing === true
		if (!acceptedMarketing) {
			return
		}
		const src = 'https://assets.calendly.com/assets/external/widget.js'
		const calendlyScript = document.querySelector("script[src*='" + src + "']")
		if (calendlyScript) {
			loadCalendly()
		} else {
			const script = document.createElement('script')
			script.async = true
			script.src = src
			script.onload = loadCalendly
			const body = document.getElementsByTagName('body')[0]
			if (body) {
				body.appendChild(script)
			}
		}
	}

	const scrollToTop = (e: MessageEvent<{ event: string }>) => {
		function isCalendlyEvent(e: MessageEvent<{ event: string }>) {
			return e.data.event && e.data.event.indexOf('calendly') === 0
		}
		if (!isCalendlyEvent(e)) return
		if (
			e.data.event == 'calendly.date_and_time_selected' ||
			e.data.event == 'calendly.event_scheduled'
		) {
			const calendlyElement = document.getElementById('book-meeting-calendly')
			const div = calendlyElement && calendlyElement.getBoundingClientRect()
			if (div) {
				window.scrollTo(0, div.top + window.pageYOffset)
			}
		}
	}

	useEffect(() => {
		// as the height of the container is a big number
		// the position of the form after some steps
		// is too down and the form is not visible to the user
		window.addEventListener('message', scrollToTop)
		void loadScript()
		return () => {
			window.removeEventListener('message', scrollToTop)
		}
	}, [])

	return <div ref={el} className="wrapper" id={`book-meeting-calendly`} />
}

export { Calendly }
